"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAutoCompoundingEventsGql = fetchAutoCompoundingEventsGql;
//import { GET_AUTOCOMPOUND_EVENTS } from "./queries.js";
//import { ApolloQueryResult } from "@apollo/client/core";
//import client from "./client.js";
const client_js_1 = require("../sui-sdk/client.js");
// interface EventNodesResponse {
//   events: {
//     pageInfo: PageInfo;
//     nodes: EventNode[];
//   };
// }
async function fetchAutoCompoundingEventsGql(eventType) {
    const allEvents = [];
    const suiClient = (0, client_js_1.getSuiClient)();
    let hasNextPage = true;
    let startCursor = null;
    const now = Date.now();
    const twentyFourHoursAgo = now - 7 * 24 * 60 * 60 * 1000; // timestamp for 24 hours ago
    while (hasNextPage) {
        const result = await suiClient.queryEvents({
            cursor: startCursor,
            order: "descending",
            query: {
                MoveEventType: eventType,
            },
        });
        const se = result.data;
        for (let i = 0; i < se.length; i++) {
            const suiEvent = se[i];
            if (Number(suiEvent.timestampMs) < twentyFourHoursAgo) {
                hasNextPage = false; // Stop further pagination
                break; // Exit the loop
            }
            const suiEventJson = suiEvent.parsedJson;
            const eventNode = {
                type: suiEvent.type,
                timestamp: Number(suiEvent.timestampMs),
                ...suiEventJson,
            };
            allEvents.push(eventNode);
        }
        // If we set hasPreviousPage to false, exit the outer loop as well
        if (!hasNextPage) {
            break;
        }
        hasNextPage = result.hasNextPage;
        startCursor = result.nextCursor;
    }
    // console.log(
    //   "counts(total, picked, page): ",
    //   totalCount,
    //   allEvents.length,
    //   pageCount,
    // );
    return allEvents;
}
// export async function fetchAutoCompoundEvents1(): Promise<EventNode[]> {
//   const allEvents: EventNode[] = [];
//   let hasPreviousPage = true;
//   let startCursor: string | null = null;
//   const now = Date.now();
//   const twentyFourHoursAgo = now - 24 * 60 * 60 * 1000; // timestamp for 24 hours ago
//   let totalCount = 0;
//   let pageCount = 0;
//   while (hasPreviousPage) {
//     pageCount += 1;
//     // Assign the entire result to a variable with a type annotation
//     // poolId: poolInfo[poolName].poolId,
//     const result: ApolloQueryResult<EventNodesResponse> = await client.query({
//       query: GET_AUTOCOMPOUND_EVENTS,
//       variables: {
//         before: startCursor,
//         eventType:
//           "0x73754ff4132adde2c28995739e8bb403aeb7219ba92003245529681dbc379c08::alphafi_navi_investor::AutoCompoundingEvent",
//       },
//     });
//     // Now destructure from the properly typed variable
//     const { data } = result;
//     const { nodes, pageInfo } = data.events;
//     totalCount += nodes.length;
//     for (let i = nodes.length - 1; i >= 0; i--) {
//       const node = nodes[i];
//       const timestampMs = new Date(node.timestamp).getTime(); // Convert to milliseconds
//       if (timestampMs < twentyFourHoursAgo) {
//         hasPreviousPage = false;
//         break;
//       }
//       // Filter events of type "AutoCompoundEvent" or other types
//       // const autoCompoundEvents = node.effects.events.nodes.filter((event) => {
//       //   if (
//       //     [
//       //       "0x73754ff4132adde2c28995739e8bb403aeb7219ba92003245529681dbc379c08::alphafi_navi_investor::AutoCompoundingEvent",
//       //     ].includes(event.type.repr)
//       //   ) {
//       //     console.log(event.type.repr);
//       //     return true;
//       //   }
//       // });
//       // allEvents.push(...autoCompoundEvents);
//       allEvents.push(node);
//     }
//     // If we set hasPreviousPage to false, exit the outer loop as well
//     if (!hasPreviousPage) {
//       break;
//     }
//     hasPreviousPage = pageInfo.hasPreviousPage;
//     startCursor = pageInfo.startCursor;
//   }
//   console.log(
//     "counts(total, picked, page): ",
//     totalCount,
//     allEvents.length,
//     pageCount,
//   );
//   return allEvents;
// }
//# sourceMappingURL=fetchAutoCompoundingEventsGql.js.map